import { Injectable, Input, SimpleChange, EventEmitter } from '@angular/core';
import { BaseService } from './BaseService';
import { APIServiceConnector } from './APIServiceConnector';
import { MetaDataCache } from '../Models/CommonModels';
import * as enumModels from '../Models/EnumModels';
import { MasterDataRequest, StaffAssignmentFilter, StaffDevice, Filter_Update_Request, ChangePasswordRequest, TagStaffRequest, UploadImageRequest } from '../Models/RequestModels';
import { UIState, UserState, ModuleMultilingualLabels } from '../Models/UIModels';
import { AppSettings } from '../Library/AppSettings';
import { StaffBasicInfo } from '../Models/GlobalEntities';
import { Staff_Search_Assigment, SimpleResponse } from '../Models/ResponseModels';
import { MasterDataService } from './MasterDataService';
import { EntityCodes } from '../Models/EnumModels';
import { HexBase64BinaryEncoding } from 'crypto';


@Injectable()
export class UserService extends BaseService {

    public StaffImageUpdated = new EventEmitter<boolean>();
    URL_WorkOrders: string;
    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService) {
        super();
        this.BaseURL = AppSettings.URL_Users;
        this.URL_WorkOrders = AppSettings.URL_WorkOrders;
    }

    Transform_Staff(PropertyId: number, arr: Array<any>): void {
        for (let i = 0; i < arr.length; i++) {
            let row = arr[i];
            row.Description = "";

            let staffId = 0;
            if (row.StaffId != undefined)
                staffId = row.StaffId;
            else if (row.id != undefined)
                staffId = row.Id;

            if (staffId > 0) {
                row.Description = this.masterService.MasterData_GetMutli(PropertyId, staffId, EntityCodes.Staff, row.Description);
            }
        }

        arr.sort((a, b) => {
            if (a.Description.toLowerCase() < b.Description.toLowerCase())
                return -1;

            if (a.Description.toLowerCase() > b.Description.toLowerCase())
                return 1;

            return 0;
        })
    }

    Staff_ForAssignment(req: StaffAssignmentFilter): Promise<Array<Staff_Search_Assigment>> {
        return this.apiService.postAPI(this.BaseURL, "Staff/Staff_ForAssignment", req).then(data => {
            if (data != null) {
                this.Transform_Staff(req.PropertyId, data);
            }

            return data;
        });
    }

    GetUserDeviceList(StaffId: number): Promise<Array<StaffDevice>> {

        return this.apiService.getAPI(this.BaseURL, "Staff/Staff_GetDevices?StaffId=" + StaffId).then(data => {
            return data;
        });
    }

    Staff_GetShiftDetails(StaffId: number): Promise<SimpleResponse> {
        return this.apiService.getAPI(this.BaseURL, "Staff/Staff_GetShiftDetails?StaffId=" + StaffId, false).then(data => {
            return data;
        })
    }

    Filter_Update(req: Filter_Update_Request): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, "Staff/Filter_Update", req, true).then(data => {
            return data;
        })
    }

    FilterSave_GetJSON(EntityCode: string): Promise<any> {
        return this.apiService.getAPI(this.BaseURL, "Staff/FilterSave_GetJSON?EntityCode=" + this.URLEncode(EntityCode), true).then(data => {
            return data;
        })
    }

    ChangePassword(req: ChangePasswordRequest): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, "Staff/Staff_ChangePassword", req, false).then(data => {
            return data;
        })
    }

    TagStaff_Get(EntityId: number, EntityCode: string): Promise<Array<number>> {
        return this.apiService.getAPI(this.BaseURL, "Staff/TagStaff_Get?EntityId=" + EntityId + "&EntityCode=" + this.URLEncode(EntityCode), true).then(data => {
            return data;
        })
    }

    TagStaff_Save(req: TagStaffRequest): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, "Staff/TagStaff_Save", req, true).then(data => {
            return data;
        })
    }

    GetOpenCalls(): Promise<SimpleResponse> {
        return this.apiService.getAPI(this.BaseURL, "Staff/Staff_GetComplainCount", false).then(data => {
            return data;
        })
    }   

    GetOpenWOs(): Promise<SimpleResponse> {
    if (!this.URL_WorkOrders) return Promise.resolve(new SimpleResponse());
        return this.apiService.getAPI(this.URL_WorkOrders, "WorkOrder/WorkOrder_GetStaffWorkOrderCount", false).then(data => {
            return data;
        })
    }

    UploadImage(req: UploadImageRequest): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, "Staff/Staff_UploadImage", req, false).then(data => {
            if(!data.HasError)
                this.StaffImageUpdated.emit(true);
            return data;
        })
    }

    AlertSound(req): Promise<SimpleResponse> {
        return this.apiService.getAPI(this.BaseURL, "Staff/Staff_AlertSound?IsAlertPopupAudioEnabled=" + req, false).then(data => {
            return data;
        })
    }
}
